var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"settings-emergency"},[_c('div',{staticClass:"emergency ma-2"},[_c('emergency')],1)])}
var staticRenderFns = []

export { render, staticRenderFns }